import { render, staticRenderFns } from "./PunchButton.vue?vue&type=template&id=cdd443da"
import script from "./PunchButton.vue?vue&type=script&lang=js"
export * from "./PunchButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports